
import { useState } from "react";
import { intl } from "LocaleWrapper";

import { Card } from "@cofano/cck";
import { Grid2 as Grid } from "@mui/material";
import Add from "@mui/icons-material/Add";

import VoyageSelect, { VoyageSelectOption } from "components/selects/VoyageSelect";

import ShipSelect, { ShipSelectOption } from "view/ships/components/selects/ShipSelect";
import VoyageAddDialog from "view/voyages/components/dialogs/VoyageAddDialog";

import { BargeType } from "__generated__/enums";

interface PushingTugPlanningSelectTugVoyage {
	onChange: (newVoyage: VoyageSelectOption | null) => void;
}

const PushingTugPlanningSelectTugVoyage = ({ onChange }: PushingTugPlanningSelectTugVoyage) => {

	const [ openAddVoyageDialog, setOpenAddVoyageDialog ] = useState(false);
	const [ pushingTug, setPushingTug ] = useState<ShipSelectOption | null>(null);
	const [ pushingTugVoyage, setPushingTugVoyage ] = useState<VoyageSelectOption | null>(null);

	const handleVoyageChange = (
		savedVoyageResult: { id: number, voyageNumber: string } | null,
	) => {
		if (!savedVoyageResult) {
			setPushingTugVoyage(null);
			onChange(null);
			return;
		}
		const transformedVoyage: VoyageSelectOption = {
			...savedVoyageResult,
			calls: [],
		};
		setPushingTugVoyage(transformedVoyage);
		onChange(transformedVoyage);
	};

	return (
		<Card
			title={intl.formatMessage({ id: "PUSHING_TUG_VOYAGE" })}
			actions={[{
				icon: <Add />,
				disabled: !pushingTug,
				onClick: () => setOpenAddVoyageDialog(true),
			} ]}>
			<Grid container spacing={3}>
				<Grid size={6}>
					<ShipSelect
						value={pushingTug}
						onChange={(option) => {
							setPushingTug(option ?? null);
							if (option?.id !== pushingTug?.id) {
								handleVoyageChange(null);
							}
						}}
						placeholder={intl.formatMessage({ id: "SELECT_A_PUSHING_TUG" })}
						additionalSearchOptions={{
							includeBargeTypes: [ BargeType.PusherTug ],
						}}
					/>
				</Grid>

				<Grid size={6}>
					<VoyageSelect
						value={pushingTugVoyage}
						disabled={!pushingTug}
						searchableShipId={pushingTug?.id}
						onChange={handleVoyageChange}
					/>
				</Grid>
			</Grid>

			{openAddVoyageDialog && pushingTug && (
				<VoyageAddDialog
					open={openAddVoyageDialog}
					ship={pushingTug}
					onClose={() => setOpenAddVoyageDialog(false)}
					onSave={handleVoyageChange}
				/>
			)}
		</Card>
	);
};

export default PushingTugPlanningSelectTugVoyage;
